import { Container, Row, Col, Card, Button, Accordion } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import R13 from '../images/R13.jpeg';
import R9 from '../images/R9.jpeg';

const Activities = () => {
  const navigate = useNavigate();

  const activities = [
    {
      id: 1,
      title: 'Morning Trip',
      duration: '3 hours 30 minutes',
      price: 'R800 Per Person',
      image: R13,
      ageRequirement: 'Please Enquire',
    },
    {
      id: 2,
      title: 'Afternoon Trip',
      duration: '3 hours 30 minutes',
      price: 'R800 Per Person',
      image: R9,
      ageRequirement: 'Please Enquire',
    }
  ];

  const handleBookNow = (tripTitle) => {
    navigate('/#contact-form', { state: { tripName: tripTitle } });
  };

  return (
    <Container fluid className="py-4 py-md-5 px-3 px-md-4">
      <Container>
        <Row className="text-center mb-4 mb-md-5">
          <Col xs={12}>
            <h1 className="display-5 display-md-4 fw-bold mb-3 mb-md-4">Our Rafting Activities</h1>
            <p className="lead px-2 px-md-0">
              Choose from our range of exciting rafting adventures, each designed to match your skill level and sense of adventure
            </p>
          </Col>
        </Row>

        {/* Activity Cards */}
        <Row className="g-3 g-md-4 mb-5">
          {activities.map((activity) => (
            <Col key={activity.id} xs={12} md={6}>
              <Card className="h-100 shadow-sm activity-card">
                <Card.Img 
                  variant="top" 
                  src={activity.image} 
                  alt={activity.title}
                  style={{ height: '200px', objectFit: 'cover' }}
                />
                <Card.Header className="bg-primary text-white">
                  <Card.Title className="h5 mb-0">{activity.title}</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Card.Text className="mb-3">
                    {activity.description}
                  </Card.Text>
                  
                  <div className="activity-details mb-3">
                    <div className="d-flex justify-content-between mb-2">
                      <span><strong>Duration:</strong></span>
                      <span>{activity.duration}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span><strong>Price:</strong></span>
                      <span className="text-primary fw-bold">{activity.price}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span><strong>Age:</strong></span>
                      <span>{activity.ageRequirement}</span>
                    </div>
                  </div>

                </Card.Body>
                <Card.Footer className="bg-transparent">
                  <Button 
                    variant="primary" 
                    className="w-100 book-now-btn"
                    onClick={() => handleBookNow(activity.title)}
                  >
                    Book Now
                  </Button>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Additional Information */}
        <Row className="mt-5">
          <Col>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>What to Bring</Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col md={6}>
                      <h6>Required Items:</h6>
                      <ul>
                        <li>Quick-dry clothing</li>
                        <li>Water shoes or secure sandals</li>
                        <li>Sunscreen</li>
                        <li>Towel</li>
                      </ul>
                    </Col>
                    <Col md={6}>
                      <h6>Recommended Items:</h6>
                      <ul>
                        <li>Sunglasses with strap</li>
                        <li>Waterproof camera</li>
                        <li>Water bottle</li>
                      </ul>
                    </Col>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
              
              <Accordion.Item eventKey="1">
                <Accordion.Header>Safety Information</Accordion.Header>
                <Accordion.Body>
                  <p>Your safety is our top priority. All our guides are certified professionals with extensive experience in white water rescue and first aid.</p>
                  <ul>
                    <li>Comprehensive safety briefing before each trip</li>
                    <li>Top-quality safety equipment provided</li>
                    <li>Regular equipment maintenance and inspection</li>
                    <li>Weather monitoring and trip adjustments as needed</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              
              <Accordion.Item eventKey="2">
                <Accordion.Header>Booking & Cancellation Policy</Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col md={6}>
                      <h6>Booking:</h6>
                      <ul>
                        <li>Advance reservation required</li>
                        <li>50% deposit to secure spot</li>
                        <li>Full payment on the day of your trip</li>
                      </ul>
                    </Col>
                    <Col md={6}>
                      <h6>Cancellation:</h6>
                      <ul>
                        <li>Weather-related cancellations receive full refund</li>
                      </ul>
                    </Col>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>

      <style jsx>{`
        .activity-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .activity-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(30, 58, 95, 0.3) !important;
        }
        .activity-details {
          font-size: 0.9rem;
        }
        .highlights ul {
          padding-left: 1.2rem;
        }
        .book-now-btn {
          background-color: var(--bs-primary) !important;
          border-color: var(--bs-primary) !important;
          transition: all 0.3s ease !important;
        }
        .book-now-btn:hover {
          background-color: #FFD700 !important;
          border-color: #FFD700 !important;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4) !important;
        }
        .book-now-btn:active {
          background-color: #FFC700 !important;
          border-color: #FFC700 !important;
          transform: translateY(0) !important;
          box-shadow: 0 2px 6px rgba(255, 215, 0, 0.4) !important;
        }
      `}</style>
    </Container>
  );
};

export default Activities;